import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeploymentRequestParams } from 'models/DeploymentRequest';

const initialState: DeploymentRequestParams = {
  offset: 0,
  requesterNameContains: undefined,
  customerReferenceNumberContains: undefined,
  salesOrderNumberContains: undefined,
  customerPurchaseOrderNumberContains: undefined,
  requestNumberContains: undefined,
  startDate: undefined,
  endDate: undefined,
  statuses: 'Draft,Posted',
  deploymentRequestType: undefined
};

export const sparingRequestsParams = createSlice({
  name: 'sparingRequestsParams',
  initialState,
  reducers: {
    setOffset: (state, { payload }: PayloadAction<DeploymentRequestParams['offset']>) => {
      state.offset = payload;
    },
    incrementOffset: (state) => {
      state.offset += 25;
    },
    setRequester: (state, { payload }: PayloadAction<DeploymentRequestParams['requesterNameContains']>) => {
      state.requesterNameContains = payload;
      state.offset = 0;
    },
    setReferenceNumber: (state, { payload }: PayloadAction<DeploymentRequestParams['customerReferenceNumberContains']>) => {
      state.customerReferenceNumberContains = payload;
      state.offset = 0;
    },
    setCustomerPurchaseOrderNumberContains: (state, { payload }: PayloadAction<DeploymentRequestParams['customerPurchaseOrderNumberContains']>) => {
      state.customerPurchaseOrderNumberContains = payload;
      state.offset = 0;
    },
    setOrderNumber: (state, { payload }: PayloadAction<DeploymentRequestParams['salesOrderNumberContains']>) => {
      state.salesOrderNumberContains = payload;
      state.offset = 0;
    },
    setRequestNumber: (state, { payload }: PayloadAction<DeploymentRequestParams['requestNumberContains']>) => {
      state.requestNumberContains = payload;
      state.offset = 0;
    },
    setStartDate: (state, { payload }: PayloadAction<DeploymentRequestParams['startDate']>) => {
      state.startDate = payload;
      state.offset = 0;
    },
    setEndDate: (state, { payload }: PayloadAction<DeploymentRequestParams['endDate']>) => {
      state.endDate = payload;
      state.offset = 0;
    },
    setStatuses: (state, { payload }: PayloadAction<DeploymentRequestParams['statuses']>) => {
      state.statuses = payload;
      state.offset = 0;
    },
    setType: (state, { payload }: PayloadAction<DeploymentRequestParams['deploymentRequestType']>) => {
      state.deploymentRequestType = payload;
      state.offset = 0;
    },
    resetParams: (state) => {
      Object.assign(state, initialState);
    }
  }
});

export const {
  setEndDate,
  incrementOffset,
  setCustomerPurchaseOrderNumberContains,
  setOrderNumber,
  setReferenceNumber,
  setRequestNumber,
  setRequester,
  setStartDate,
  setStatuses,
  setOffset,
  resetParams,
  setType
} = sparingRequestsParams.actions;
